export default "__VITE_ASSET__CZQpIGbF__"